const trackEvent = (eventName, payload) => {
  if (typeof window === 'undefined' || typeof window._satellite === 'undefined') {
    console.warn(
      `%c[ANALYTICS] Adobe Launch not available — event dropped: ${eventName}`,
      'color: orange; font-weight: bold',
      payload
    );
    return;
  }

  try {
    window._satellite.track(eventName, payload);
    console.log(
      `%c[ANALYTICS] ${eventName} › ${payload.event_category || payload.event || ''} @ ${new Date().toISOString()}`,
      'color: #4caf50; font-weight: bold; font-size: 11px',
      {
        satellite_event: eventName,
        event: payload.event,
        event_category: payload.event_category,
        event_label: payload.event_label,
        sku: payload.sku,
        url: window.location.href,
        tc_vars: { ...window.tc_vars },
        full_payload: payload
      }
    );
  } catch (error) {
    console.error(
      `%c[ANALYTICS] Error tracking event: ${eventName}`,
      'color: red; font-weight: bold',
      { payload, error }
    );
  }
};

export const trackSubmitLetters = (label) => {
  trackEvent('digitalcatalog', {
    event: 'cta_click',
    event_category: 'submit_letters',
    event_label: label || ''
  });
};

export const trackSelectProduct = (sku) => {
  trackEvent('digitalcatalog', {
    event: 'cta_click',
    event_category: 'select_product',
    sku: sku || ''
  });
};

export const trackConfirmSelection = (sku, label) => {
  trackEvent('digitalcatalog', {
    event: 'cta_click',
    event_category: 'confirm_selection',
    sku: sku || '',
    event_label: label || ''
  });
};

export const trackUpdateLetters = (label) => {
  trackEvent('digitalcatalog', {
    event: 'cta_click',
    event_category: 'update_letters',
    event_label: label || ''
  });
};

export const trackUpdateProduct = (sku) => {
  trackEvent('digitalcatalog', {
    event: 'cta_click',
    event_category: 'update_product',
    sku: sku || ''
  });
};

export const trackFinalizeSelection = (sku, label) => {
  trackEvent('digitalcatalog', {
    event: 'cta_click',
    event_category: 'finalize_selection',
    sku: sku || '',
    event_label: label || ''
  });
};

export const trackClosingCTA = (label) => {
  const validLabels = ['explore_boutique_catalogue', 'restart_the_experience'];
  const normalizedLabel = validLabels.includes(label) ? label : 'unknown';

  trackEvent('digitalcatalog', {
    event: 'cta_click',
    event_category: 'closing_cta',
    event_label: normalizedLabel
  });
};

export const trackLanguageChange = (language) => {
  const validLanguages = ['cht', 'chs', 'jp', 'en', 'it', 'fr', 'es', 'ko', 'de', 'ru'];
  const normalizedLanguage = validLanguages.includes(language) ? language : 'unknown';
  
  trackEvent('digitalcatalog', {
    event: 'language_change',
    event_category: 'language_switcher',
    event_label: normalizedLanguage,
    language: normalizedLanguage
  });
};

export const trackClick = (category, label, additionalData = {}) => {
  trackEvent('digitalcatalog', {
    event: 'click',
    event_category: category || 'general_click',
    event_label: label || '',
    ...additionalData
  });
};

